import { useEffect, useState } from "react"
import { Button } from "react-bootstrap"
import { createColumnHelper } from "@tanstack/react-table"
import { ApiEndpoints, reqGetNew } from "../../../config/apiClient"
import DataTable from "../../../components/dataTable/DataTable"

function InsumosLocaisPage() {
    const [dados, setDados] = useState<InsumoLocalDto[]>([])

    useEffect(() => {
        document.title = "Insumos Locais | OB PORTUS"
        listarDados()
    }, [])

    async function listarDados() {
        const api = await reqGetNew(ApiEndpoints.insumosLocais)
        if (api.status === 200) {
            const dadosAux:InsumoLocalDto[] = api.data
            console.log(api.data)
            setDados(dadosAux)
        }
    }

    function tableMiddleClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = dados[idx]
        const link = `${URL_BASE}/editar?id=${reg.id_local}`

        if (event.button === 1) {
            window.open(link)
        }
    }

    function tableClickhandler(event:any) {
        const idx = Number(event.target.parentElement.getAttribute('about'))
        const reg = dados[idx]
        const link = `${URL_BASE}/editar?id=${reg.id_local}`

        if (event.button === 0) {
            window.location.assign(link)
        }
    }

    return (
        <div id="main">
            <div className="div-row-space-between">
                <h1 id="titleMain">Insumos Locais</h1>
                <div className="div-row">
                    <Button onClick={() => {
                        window.location.assign(`${URL_BASE}/cadastrar`)
                    }}>Cadastrar</Button>
                </div>
            </div>
            <br></br>
            {<DataTable dados={dados} tableSize={'auto'} defaultColumns={defaultColumns} tableMiddleClickhandler={tableMiddleClickhandler} tableClickhandler={tableClickhandler} defaultOrder={defaultOrder} />}
        </div>
    )
}

export default InsumosLocaisPage
interface InsumoLocalDto {
    id_local: number
    descricao: string
    situacao: number
    produtos: any[]
}
const URL_BASE = "/insumos/local"

const columnHelper = createColumnHelper<InsumoLocalDto>()
const defaultColumns = [
    columnHelper.accessor('id_local', {
        header: 'Cod.',
        size: 10,
    }),
    columnHelper.accessor('descricao', {
        header: 'Descrição Local',
    }),
    columnHelper.accessor(row => `${row.produtos.length} Produtos`, {
        header: 'Quantidade',
    }),
    columnHelper.accessor(row => `${row.situacao === 1 ? `Ativo` : `Desativado`}`, {
        header: 'Situação',
        size: 30,
    }),
]
const defaultOrder:any = []
